import { t } from "i18next"
import { FormError } from "@/components/ui/form"
import { RadioGroup, RadioGroupItem, RadioGroupLabel } from "@/components/ui/radio-group"
import { TooltipContent, TooltipCustom, TooltipPortal, TooltipTrigger } from "@/components/ui/tooltip"
import { cn } from "@/lib/utils"
import { REASON_POINT_OF_CARE_ITEMS } from "@/modules/patients/detail/progress-note/point-of-care/constants"

interface ReasonPointOfCareSelectionProps extends React.ComponentPropsWithoutRef<typeof RadioGroup> {
  label?: string
  containerClassName?: string
  error?: string
}

export const ReasonPointOfCareSelection = (props: ReasonPointOfCareSelectionProps) => {
  const { label, className, containerClassName, error, ...rest } = props
  return (
    <div className={cn("flex flex-col gap-2", containerClassName)} data-testid="reason-for-choosing-selection">
      <label className="text-on-surface-subdued text-sm leading-5">{label}</label>
      <RadioGroup className={cn("grid-flow-col justify-start gap-2", className)} {...rest}>
        {REASON_POINT_OF_CARE_ITEMS.map((item) => (
          <div key={item.value}>
            <TooltipCustom data-testid="reason-for-choosing-tooltip">
              <TooltipTrigger asChild>
                <RadioGroupItem
                  data-testid={`reason-for-choosing-${item.value}-radio-button`}
                  className="w-auto"
                  value={item.value}
                  id={item.value}>
                  <RadioGroupLabel className="capitalize" htmlFor={item.value}>
                    {item.label}
                  </RadioGroupLabel>
                </RadioGroupItem>
              </TooltipTrigger>
              {item.tooltip ? (
                <TooltipPortal>
                  <TooltipContent side="top" align="start">
                    {item.tooltip}
                  </TooltipContent>
                </TooltipPortal>
              ) : null}
            </TooltipCustom>
          </div>
        ))}
      </RadioGroup>
      {error && <FormError>{t("common.fieldErrorList.requiredField")}</FormError>}
    </div>
  )
}
